import { Location } from '@angular/common';
import { Directive, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[backbutton]'
})
export class BackbuttonDirective {

  constructor(private location: Location, private router: Router) { }

  @HostListener('click')
  onClick() {
    this.location.back();
  }

}
